// 定时器任务在这里统一管理


// 定时任务数组
let timeOutList = []

// 循环定时任务数组
let intervalList = []

// 创建一个定时器任务
function createTimeOut(doFun, overTime) {
  try {
    timeOutList.push(
      setTimeout(doFun, overTime)
    )
  } catch (error) {
    console.error("创建定时器任务失败！")
  }
  return timeOutList.length - 1
}

// 创建循环定时任务
export function createInterval(doFun, time) {
  try {
    intervalList.push(
      setInterval(doFun, time)
    )
  } catch (error) {
    console.error("创建循环定时任务失败！")
  }
  return intervalList.length - 1
}

/**
 *  依据下标注销定时器
 *  如果下标为 null、undefined、false, 则清除所有定时器
 */
function clearTimeOutByindex(index) {
  try {
    if(index || index==0){
      if(timeOutList[index]){
        window.clearTimeout(timeOutList[index])
      }
      timeOutList[index] = null
    }else{
      for(let i =0; i < timeOutList.length; i++){
        window.clearTimeout(timeOutList[i])
      }
      timeOutList = []
    }
  } catch (error) {
    
  }
}

/**
 *  依据下标注销循环定时任务
 *  如果下标为 null、undefined、false, 则清除所有循环定时任务
 */
export function clearIntervalByindex(index) {
  try {
    if(index || index==0){
      if(intervalList[index]){
        window.clearInterval(intervalList[index])
      }
      intervalList[index] = null
    }else{
      for(let i =0; i < intervalList.length; i++){
        window.clearInterval(intervalList[i])
      }
      intervalList = []
    }
  } catch (error) {
    console.error("注销循环定时任务失败！")
  }
}

// 注销所有定时器和循环定时任务
export function clearAllTime() {
  try {
    clearTimeOutByindex(null)
    clearIntervalByindex(null)
  } catch (error) {
    console.error("注销所有定时器和循环定时任务失败！")
  }
}

export default {
  install: function (Vue) {
    Vue.prototype.$createTimeOut = (doFun, overTime)=>createTimeOut(doFun, overTime)
    Vue.prototype.$createInterval = (doFun, time)=>createInterval(doFun, time)
    Vue.prototype.$clearTimeOutByindex = (index)=>clearTimeOutByindex(index)
    Vue.prototype.$clearIntervalByindex = (index)=>clearIntervalByindex(index)
    // 注销所有定时器
    Vue.prototype.$clearAllTimeOutByindex = ()=>clearTimeOutByindex(null)
    // 注销所有循环定时任务
    Vue.prototype.$clearAllIntervalByindex = ()=>clearIntervalByindex(null)
    // 注销所有定时器和循环定时任务
    Vue.prototype.$clearAllTime = ()=>clearAllTime()
  }
}





// WEBPACK FOOTER //
// ./src/util/timerTask.js